(function ($) {
  "use strict";

  // var searchInputSelector = '#header-search-form_Search';
  var searchInputSelector =
    "#search-page-form_Search, #header-search-form_Search";
  var currentInputId = "header-search-form_Search";
  var isScrolling = false;
  var isNavigating = false;
  var hasResults = false;
  var resultTabIndex = 0;

  var indexName = "live_index";

  if (!!window._testEnvironment) {
    indexName = "test_index";
  }

  var searchUri = `https://ma9ztc5vtf-dsn.algolia.net/1/indexes/${indexName}/query`;

  const resultFields = ["title", "breadcrumbs", "link"];
  const resultFieldsParameter = resultFields.reduce(
    (acc, fieldName) => ({ ...acc, [fieldName]: { raw: {} } }),
    {}
  );

  /**
   * Exclude page types by their PHP class name. Must be an exact match.
   * Changes here should also be reflected in PageController::getClassesToSearch()
   * @type {string[]}
   */
  const includedClasses = [
    "objectClassName:Heyday\\WorkSafe\\Pagetypes\\HomePage",
    "objectClassName:Heyday\\WorkSafe\\Pagetypes\\ContentPages\\ContentPage",
    "objectClassName:Heyday\\WorkSafe\\Pagetypes\\LandingPage\\Variations\\TopicsIndustryLandingPage",
    "objectClassName:Heyday\\WorkSafe\\Pagetypes\\LandingPage\\LandingPage",
    "objectClassName:Heyday\\WorkSafe\\Pagetypes\\LandingPage\\Variations\\EnergyAccidentIndexPage",
    "objectClassName:Heyday\\WorkSafe\\Pagetypes\\ContentPages\\LongFormDocument",
    "objectClassName:Heyday\\WorkSafe\\Pagetypes\\LandingPage\\Variations\\AsbestosLicenceHolderIndexPage",
    "objectClassName:Heyday\\WorkSafe\\Pagetypes\\NotifiableEvents\\NotifiableEventsPage",
    "objectClassName:Heyday\\WorkSafe\\Pagetypes\\Contact\\SubscriptionsPage",
    "objectClassName:Heyday\\WorkSafe\\Pagetypes\\Contact\\ContactUsForm",
    "objectClassName:SilverStripe\\UserForms\\Model\\UserDefinedForm",
    "objectClassName:Heyday\\WorkSafe\\Pagetypes\\Forms\\ExtractivesFormPage",
  ];

  var scrollTimeout;
  var searchTimeout = setTimeout(function () {}, 1);

  // Create element holder for autocomplete items;
  var items = document.createElement("div");
  items.className =
    "search-form__autocompleteitems form__autocompleteitems--search";
  $("#search-page-form_Search").parent().append(items);

  var headerItems = document.createElement("div");
  headerItems.className = "search-form__autocompleteitems";
  $("#header-search-form_Search").parent().append(headerItems);

  // Clear all items in the autocomplete.
  function clearResults() {
    items.innerHTML = "";
    headerItems.innerHTML = "";
    isNavigating = false;
    hasResults = false;
    resultTabIndex = 0;

    window.removeEventListener("keyup", enableKeyNavigation);
  }

  // Array results formatted as list.
  function renderSearchResults(results, query) {
    clearResults();

    if (results.length) {
      hasResults = true;

      var resultsEl = document.createElement("div");
      var itemHeader = document.createElement("div");
      itemHeader.className =
        "search-form__autocompleteitem search-form__autocompleteitem--header";
      itemHeader.innerHTML = `Suggested pages for "${query}"`;

      resultsEl.appendChild(itemHeader);

      results.forEach(function (result, index) {
        var item = document.createElement("a");
        var suggestion = result.objectTitle.replace(/ /gi, "+");

        var title = document.createElement("h3");
        item.appendChild(title);
        var breadcrumbs = document.createElement("p");
        breadcrumbs.className = "search-form__hint";

        if (!!result.breadcrumbs && !!result.breadcrumbs) {
          breadcrumbs.innerHTML = result.breadcrumbs;
          item.appendChild(breadcrumbs);
        }

        item.className = `search-form__autocompleteitem search-form__autocompleteitem--result search-form__autocompleteitem--${
          index + 1
        }`;
        item.setAttribute(
          "href",
          result?.objectLink
            ? new URL(result.objectLink).pathname
            : `search/SearchForm/?Search=${suggestion}&action_results=Go`
        );
        item.setAttribute("tabindex", `0`);
        item.setAttribute("title", result?.objectTitle);
        title.innerHTML = result?.objectTitle;
        resultsEl.appendChild(item);
      });

      var itemFooter = document.createElement("div");
      itemFooter.className =
        "search-form__autocompleteitem search-form__autocompleteitem--footer";

      var itemFooterTitle = document.createElement("a");
      itemFooterTitle.className = "search-form__action button button--primary";
      itemFooterTitle.innerHTML = `Show more`;
      itemFooterTitle.setAttribute(
        "href",
        `search/SearchForm/?Search=${query}&action_results=Go`
      );

      var itemFooterClose = document.createElement("button");
      itemFooterClose.className = "search-form__action button button--outline";
      itemFooterClose.innerHTML = `Close`;
      itemFooterClose.addEventListener("click", clearResults);

      itemFooter.appendChild(itemFooterTitle);
      itemFooter.appendChild(itemFooterClose);

      resultsEl.appendChild(itemFooter);

      if (currentInputId === "header-search-form_Search") {
        headerItems.appendChild(resultsEl);
      } else {
        items.appendChild(resultsEl);
      }
    }
  }

  function makeSearchQuery(query) {
    $.ajax(searchUri, {
      dataType: "json",
      data: JSON.stringify({
        query: query,
        optionalWords: query,
        page: 0,
        hitsPerPage: 5,
        facetFilters: [[includedClasses]],
      }),
      crossDomain: true,
      type: "POST",
      beforeSend: function (xhr) {
        xhr.setRequestHeader("X-Algolia-Application-Id", `MA9ZTC5VTF`);
        xhr.setRequestHeader(
          "X-Algolia-API-Key",
          `8ddeb815149bdab6f4d869ac37620274`
        );
        xhr.setRequestHeader("Content-Type", "application/json");
      },
      error: function (jqXHR, textStatus, exception) {
        console.log("error");
      },
      success: function (jsonData, textStatus, jqXHR) {
        renderSearchResults(jsonData.hits, query);
        window.addEventListener("touchmove", blurForScroll);
        window.addEventListener("keyup", enableKeyNavigation);
      },
    });
  }

  // Set the value of the input an use to trigger search query
  function setInputValue(value) {
    clearTimeout(searchTimeout);

    if (value === "") {
      clearResults();
    } else if (value.length > 1) {
      searchTimeout = setTimeout(function () {
        makeSearchQuery(value);
      }, 200);
    }
  }

  function enableKeyNavigation(event) {
    if (event.keyCode === 9) {
      isNavigating = true;
    }

    if (hasResults) {
      handleKeyNavigation(event);
    }
  }

  function blurForScroll() {
    isScrolling = true;
    $(searchInputSelector).blur();

    window.removeEventListener("touchmove", blurForScroll);
  }

  function handleKeyNavigation(event) {
    if (event.keyCode === 40 || event.keyCode === 38) {
      event.preventDefault();

      isNavigating = true;

      resultTabIndex =
        event.keyCode === 40 ? resultTabIndex + 1 : resultTabIndex - 1;

      if (resultTabIndex < 1) {
        resultTabIndex = 1;
        $(searchInputSelector).focus();
      } else if (resultTabIndex > 5) {
        resultTabIndex = 1;
        document
          .querySelector(`.search-form__autocompleteitem--${resultTabIndex}`)
          .focus();
      } else {
        document
          .querySelector(`.search-form__autocompleteitem--${resultTabIndex}`)
          .focus();
      }
    }
  }

  // on keypress set the input value
  $(searchInputSelector).keyup(function (e) {
    if (e.target.getAttribute("enableSuggestions")) {
      if (event.keyCode === 40 && hasResults) {
        isNavigating = true;

        $(searchInputSelector).blur();
      } else {
        var value = $(this).val();

        currentInputId = $(this).attr("id");

        setInputValue(value);
      }
    }
  });

  // on focus set the input value
  $(searchInputSelector).focus(function (e) {
    if (e.target.getAttribute("enableSuggestions")) {
      var value = $(this).val();

      currentInputId = $(this).attr("id");

      setInputValue(value);
    }
  });

  // on blur clear the search results
  $(searchInputSelector).blur(function () {
    // Allow time for click events on suggestions to register
    clearTimeout(scrollTimeout);

    scrollTimeout = setTimeout(function () {
      if (!isScrolling && !isNavigating) {
        clearResults();
      } else {
        isScrolling = false;
      }
    }, 250);
  });
})(jQuery);
